import { INITIAL_TEAM_NAVIGATION } from '@atom/hooks/useTeamNavigation';
import { INITIAL_INPUT } from '@atom/hooks/useWorkOrdersFilters';
import { INITIAL_WORK_TEMPLATES_VIEW } from '@atom/hooks/useWorkTemplatesView';
import { INITIAL_WORK_VALIDATIONS } from '@atom/hooks/useWorkValidations';
import defaultProfileImage from '@atom/images/defaultProfileImage.png';
import { ReduxStore } from '@atom/types/store';

const auth = {
  isVerified: false,
  isLoggedIn: false,
  permissions: [],
};

const exportTemplateDetail = {
  id: '',
  name: '',
  createdBy: '',
  createdDate: 0,
  updatedBy: '',
  updatedDate: 0,
  isPublished: false,
  categoryIds: [],
  schemas: {},
};

const formInstance = {
  id: '',
  name: '',
  createdDate: 0,
  createdBy: '',
  pages: [
    {
      id: '1',
      name: 'Page 1',
      fields: {},
      order: [],
    },
  ],
  media: {},
};

const formTemplateDetail = {
  id: '',
  name: '',
  createdDate: 0,
  createdBy: '',
  pages: [
    {
      id: '1',
      name: 'Page 1',
      fields: {},
      order: [],
    },
  ],
};

const inventory = {
  categories: {
    inventoryPortalPath: {
      id: 'inventory',
      path: 'inventory',
    },
    inventoryCategory: '',
    inventoryCategoryTree: {
      id: 'inventory',
      name: 'Inventory',
      assetType: '',
      expanded: false,
      children: [],
      hasChildren: true,
    },
  },
  data: [],
  columns: [],
  filters: {},
  sort: {},
};

const inventoryFilterCategoryTree = [
  {
    id: 'inventory',
    name: 'Inventory',
    hasCategories: true,
    expanded: false,
  },
];

const loading = {
  loadingTenantCreation: false,
  loadingInventory: false,
  loadingUserLogin: false,
  loadingOrganizations: false,
  loadingUserRegistration: false,
  retrievedUser: false,
  loadingInventorySchema: true,
  loadingInventorySchemas: false,
  loadingInventorySchemasByIds: true,
  loadingInventorySchemaTree: false,
  loadingElementBatchCreation: false,
  loadingMedia: false,
  loadingMediaFolders: false,
  loadingFormTemplateCreation: false,
  loadingFormTemplateUpdate: false,
  loadingFormTemplate: false,
  loadingFormTemplates: true,
  loadingFormInstance: true,
  loadingInventoryFilterCategoryTreeNode: false,
  loadingSchemaDetail: true,
  loadingSchemaTreeNode: false,
  savingFormInstance: false,
  loadingApplicationSearch: false,
  loadingCharts: true,
  loadingWorkTemplates: true,
  loadingWorkTemplateCreation: false,
  loadingElementDelete: false,
  loadingMediaRename: false,
  loadingExportTemplates: false,
  loadingExportTemplateCreation: false,
  loadingExportTemplateDetail: false,
  loadingFullCategoryTree: false,
};

const mediaFolderTree = {
  id: 'root',
  name: 'All Files',
};

const mediaTotals = {
  document: { name: 'Documents', count: 0 },
  image: { name: 'Photos', count: 0 },
  video: { name: 'Videos', count: 0 },
};

const userProfile = {
  userId: '',
  firstName: '',
  lastName: '',
  department: '',
  role: '',
  email: '',
  isActive: false,
  isVerified: false,
  profileImage: defaultProfileImage,
  location: {
    type: 'Point',
    coordinates: [0, 0],
  },
  phoneNumber: '',
  title: '',
};

const initialState: ReduxStore = {
  arcgisLayerData: {},
  auth,
  exportTemplateDetail,
  exportTemplates: [],
  formInstance,
  formTemplateDetail,
  formTemplates: [],
  formTemplatesTotal: 0,
  inventory,
  inventoryFilterCategoryTree,
  inventoryFullCategoryTree: {},
  inventoryNavigation: {},
  // @ts-ignore
  inventorySchema: {},
  // @ts-ignore
  inventorySchemaDetail: {},
  inventorySchemas: [],
  inventorySchemasByIds: {},
  inventorySchemaTree: {},
  inventoryTotal: 0,
  loading,
  media: [],
  mediaFolders: [],
  mediaFolderTree,
  mediaTotal: 0,
  // @ts-ignore
  mediaTotals,
  organizations: [],
  poolAttributes: [],
  preferences: {},
  teamNavigation: INITIAL_TEAM_NAVIGATION,
  // @ts-ignore
  userProfile,
  workOrdersInput: INITIAL_INPUT,
  workTemplates: [],
  workTemplatesTotal: 0,
  workTemplatesView: INITIAL_WORK_TEMPLATES_VIEW,
  workValidations: INITIAL_WORK_VALIDATIONS,
};

export default initialState;
